import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Modal,
  ScrollView,
  TouchableOpacity,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import { useTranslation } from "react-i18next";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import ExerciseHistoryList from "./ExerciseHistoryList";
import HoverableTouchableOpacity from "../../Components/HoverableTouchableOpacity";
import GlobalStyles from "../../../Resources/Styles";
import { useDevice, useScreenDimensions } from "../../_layout";

const ExerciseHistoryModal = ({ isVisible, exercise, client, onClose }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useDevice();
  const { screenSize } = useScreenDimensions();
  const [isCloseHovered, setIsCloseHovered] = useState(false);

  if (!isVisible) return null;

  const exerciseName =
    exercise?.getName?.(t, i18n.language) ??
    exercise?.name ??
    t("exercise-string");

  return (
    <Modal
      visible={isVisible}
      transparent={true}
      animationType="fade"
      onRequestClose={onClose}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={onClose}
          style={GlobalStyles.touchableBackground}
          activeOpacity={1}
        />
        <View
          style={[
            styles.modalView,
            isMobile && { maxHeight: "90%" },
            screenSize === "small" && { maxHeight: "95%" },
          ]}
        >
          <View style={styles.header}>
            <View style={styles.headerTextBlock}>
              <Text numberOfLines={1} style={styles.title}>
                {exerciseName}
              </Text>
              <Text style={styles.subtitle}>{t("history-string")}</Text>
            </View>
            <HoverableTouchableOpacity
              onPress={onClose}
              style={styles.closeButton}
              hoverStyle={undefined}
              onMouseEnter={() => !isMobile && setIsCloseHovered(true)}
              onMouseLeave={() => setIsCloseHovered(false)}
            >
              <Feather
                name="x"
                size={20}
                color={isCloseHovered ? Colors.darkgrayColor : Colors.grayColor}
              />
            </HoverableTouchableOpacity>
          </View>
          <ScrollView
            style={styles.content}
            contentContainerStyle={styles.contentContainer}
            showsVerticalScrollIndicator={true}
            keyboardShouldPersistTaps="handled"
          >
            <ExerciseHistoryList client={client} exercise={exercise} />
          </ScrollView>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    backgroundColor: Colors.whiteColor,
    borderRadius: 18,
    padding: 16,
    width: "90%",
    maxWidth: 560,
    alignSelf: "center",
    zIndex: 1000,
    elevation: 10,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.2,
    shadowRadius: 4.65,
    flexDirection: "column",
    maxHeight: "100%",
  },
  header: {
    paddingBottom: 12,
    borderBottomWidth: 0.5,
    borderBottomColor: Colors.borderColor,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 8,
  },
  headerTextBlock: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontSize: 13,
    fontWeight: "500",
    color: Colors.darkgrayColor,
  },
  subtitle: {
    fontSize: 10,
    fontWeight: "500",
    color: Colors.grayColor,
    marginTop: 2,
    textTransform: "uppercase",
    letterSpacing: 0.5,
  },
  closeButton: {
    padding: 6,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    paddingBottom: 12,
  },
});

export default ExerciseHistoryModal;
